import React from "react";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { defineMessages, useIntl } from "@mnemonic/intl";
import { TypographyMonospace } from "@mnemonic/mui";

import { commonMessages } from "../commonMessages";
import type { TAPIStatusList, TServiceList } from "./useUrlParams";
import { API_STATUS_LIST, SERVICE_LIST, useUrlParams } from "./useUrlParams";

const apiStatusMessages = defineMessages<TAPIStatusList>({
  PUBLIC: { id: "apiStatus.PUBLIC", defaultMessage: "Public" },
  INTERNAL: { id: "apiStatus.INTERNAL", defaultMessage: "Internal" },
  DEV: { id: "apiStatus.DEV", defaultMessage: "Development" },
  ALL: { id: "apiStatus.ALL", defaultMessage: "All" },
});

const messages = defineMessages({
  apiStatusWarning: {
    id: "apiStatusWarning",
    defaultMessage: "Non public endpoints can change, use them at your own risk",
  },
});

export const SwaggerHeader = () => {
  const { formatMessage } = useIntl();
  const { urlParams, updateUrlParams } = useUrlParams();
  const { apistatus, module } = urlParams;

  const showApiStatusWarning = apistatus !== "PUBLIC";

  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <Box display="flex" gap={1} alignItems="center">
        <TypographyMonospace variant="h6">Swagger for</TypographyMonospace>
        <FormControl sx={{ width: 190 }}>
          <InputLabel>{formatMessage(commonMessages.Argusservice)}</InputLabel>
          <Select<TServiceList>
            size="small"
            value={module}
            label={formatMessage(commonMessages.Argusservice)}
            onChange={(e) => updateUrlParams({ module: e.target.value as TServiceList })}
          >
            {SERVICE_LIST.map((service) => (
              <MenuItem key={service} value={service}>
                {service.charAt(0).toUpperCase() + service.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box display="flex" gap={1}>
        {showApiStatusWarning && (
          <Alert icon={<WarningAmberIcon />} color="warning" sx={{ py: 0 }}>
            {formatMessage(messages.apiStatusWarning)}
          </Alert>
        )}

        <FormControl sx={{ width: 150 }}>
          <InputLabel>{formatMessage(commonMessages.APIstatus)}</InputLabel>
          <Select
            size="small"
            value={apistatus || "ALL"}
            label={formatMessage(commonMessages.APIstatus)}
            onChange={(e) => {
              updateUrlParams({ apistatus: e.target.value as TAPIStatusList });
            }}
          >
            {API_STATUS_LIST.map((status) => (
              <MenuItem key={status} value={status}>
                {formatMessage(apiStatusMessages[status])}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
